'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fass';
var iconName = 'swatchbook';
var width = 512;
var height = 512;
var aliases = [];
var unicode = 'f5c3';
var svgPathData = 'M0 416c0 53 43 96 96 96s96-43 96-96L192 0 0 0 0 416zM128 64l0 64-64 0 0-64 64 0zm0 128l0 64-64 0 0-64 64 0zM72 416a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm108.7 96L512 512l0-192-139 0L186.5 506.5c-1.9 1.9-3.8 3.7-5.8 5.5zM458 189.7L322.3 54 224 152.2l0 271.5 234-234z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faSwatchbook = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;